import React, { memo, forwardRef } from "react";
const SvgCapitalPhi = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.824 24.136a1 1 0 01-1-1v-1.16c-1.584-.032-2.888-.256-3.912-.672-1.008-.416-1.8-.952-2.376-1.608a6.295 6.295 0 01-1.2-2.16A8.284 8.284 0 017 15.256c0-.848.128-1.664.384-2.448s.68-1.48 1.272-2.088c.592-.624 1.392-1.12 2.4-1.488 1.008-.384 2.264-.584 3.768-.6V8a1 1 0 011-1h.136a1 1 0 011 1v.632c1.52.016 2.784.208 3.792.576s1.8.856 2.376 1.464a5.31 5.31 0 011.272 2.112 7.913 7.913 0 01.024 4.8 5.691 5.691 0 01-1.248 2.16c-.576.64-1.376 1.168-2.4 1.584-1.008.4-2.28.616-3.816.648v1.16a1 1 0 01-1 1h-.136zm-1-3.936v-9.744c-1.44.032-2.576.264-3.408.696-.816.416-1.392.976-1.728 1.68-.336.704-.504 1.504-.504 2.4 0 .944.184 1.784.552 2.52.384.736.984 1.32 1.8 1.752.832.416 1.928.648 3.288.696zm2.136 0c1.392-.048 2.496-.288 3.312-.72.832-.448 1.424-1.04 1.776-1.776.368-.736.552-1.56.552-2.472 0-.912-.168-1.72-.504-2.424-.336-.704-.912-1.264-1.728-1.68-.816-.416-1.952-.64-3.408-.672V20.2z"
      />
    </svg>
  );
});
SvgCapitalPhi.displayName = "SvgCapitalPhi";
const MemoForwardRef = memo(SvgCapitalPhi);
export default MemoForwardRef;
